<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <!-- <router-link class="btn btn-orange" title="Back to settings" :to="{ path: '/settings'}"><i class="ti-arrow-left"></i> Back</router-link> -->
      <p></p>
      <kds-section-form :route="route" @on-submit="onSubmit"></kds-section-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import KdsSectionForm from './KdsSectionForm'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      KdsSectionForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        kdsSectionModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onSubmit (model, isValid) {
        this.kdsSectionModel = model
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Sections/KdsSectionAdd.vue